import React, { Component } from 'react'

import mission from "../images/mission.png";
import quote from "../images/quote.png"; 

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Congratulations from './Congratulations'



export class ShareDetails extends Component {
  constructor(props){
    super(props);
    this.state={
      userName: "",
      coachingName: "",
      mobileNumber: "",
      utm_source: "",
      utm_medium: "",
      utm_campaign: "",
      submitDisabled: true,
      isSubmitted: false,
    }
  }

  componentDidMount(){
    let utm_source = this.getQuery()['utm_source'];
    let utm_medium = this.getQuery()['utm_medium'];
    let utm_campaign = this.getQuery()['utm_campaign'];
    this.setState({utm_source, utm_medium, utm_campaign});
  }

  getQuery = () => {
    let b = window.location.search.slice(1).split('&').map((qStr) => qStr.split('=')).reduce((acc, inc) => {
      acc[inc[0]] = inc[1];
      return acc;
    }, {});
    return b;
  }

  handleFormValueChange = (inputName, event) => {
    let stateValue = {};
    stateValue[inputName] =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState(stateValue);    
      this.buttonEnable();

  }

  handleMobileInput = (inputName, event) => {
    const re = /^[7-9][0-9]{9}$/;
    if (event.target.value.length <= 10 || re.test(event.target.value)) {
      let stateValue = {};
      stateValue[inputName] = event.target.value;
      this.setState(stateValue);
      if(event.target.value.length === 10){
      this.buttonEnable();
      } else{
        this.setState({
          submitDisabled: true
        })  
      }
    }
 }

 buttonEnable = () => {
   let {userName, coachingName, mobileNumber} = this.state

   if(userName && coachingName && mobileNumber){
     this.setState({
       submitDisabled: false
     })
   } else {
     this.setState({
       submitDisabled: true
     })
   }
 }

  handleSubmit = (event) => {
    // event.preventDefault();

    let error = false;
    if(!(this.state.userName && this.state.coachingName && this.state.mobileNumber)) {
      error = true;
    }
    if(!error) {
      this.setState({ disableContactBtn: true });

      this.handleApiSendFn()

      // this.toggleCongratulations()
      // toast.dark("Successfully Sumbitted Details")

    } else {

      this.setState({ disableContactBtn: false });
      alert("Please enter Valid Details")


    }
    
  }


  handleApiSendFn = () =>{

    const {userName, coachingName, mobileNumber, utm_source, utm_medium, utm_campaign} = this.state;

    let payload = {
      type: "classplus_biographies",
      userName: userName,
      coachingName: coachingName,
      // city: city && city.label,
      // state:city && city.label,
      // identity: userType,
      mobileNumber,
      // emailid: email,
      campaignName: utm_campaign,
      utmSource: utm_source,
      utmMedium: utm_medium,
      // isOptIn: isSMSAllowed ? 1 : 0,
    };
    fetch(
      //'http://sales-incentive.classplus.co/newapi/saveonlineleads.php',
      "https://crm.classplus.co/su/website",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    )
      .then(
        //  res => console.log(res, 'palash reesp')
        this.toggleCongratulations(),
        // this.successPopUp(),
         this.clearFormData()
      )
      .catch((err) => toast.error("Something went wrong"));

  }

  clearFormData = () => {
    this.setState({
      userName: '',
      coachingName: '',
      mobileNumber: ''
    })
  }

  toggleCongratulations = () => {
    this.setState({
      isSubmitted: !this.state.isSubmitted
    })
  }

  render() {
    const {submitDisabled, isSubmitted} = this.state
    return (
      <div className="ShareDetails">
      <div className="ShareDetails__Col1">
        <img className="ShareDetails__Col1--Img" src={mission} alt="" />
        <div className="ShareDetails__Col1--Content">
          <img
            className="ShareDetails__Col1--Content__Img1"
            src={quote}
            alt=""
          />
          <div className="ShareDetails__Col1--Content__Para">
          Audition for Classplus Teachers' Biographies
          </div>
          <img
            className="ShareDetails__Col1--Content__Img2"
            src={quote}
            alt=""
          />
        </div>
      </div>
      <div className="ShareDetails__Col2">
        <div className="ShareDetails__Col2--Head">
        Want to know the process of becoming a part of this series?
        </div>
        <div className="ShareDetails__Col2--Label">Coaching Name</div>
        <input 
          type="text"
          className="ShareDetails__Col2--Input" 
          onChange={e => this.handleFormValueChange("coachingName", e)} 
          value={this.state.coachingName} 
        />

        <div className="ShareDetails__Col2--Label">Your Name</div>
        <input 
          type="text"
          className="ShareDetails__Col2--Input" 
          onChange={e => this.handleFormValueChange("userName",e)} 
          value={this.state.userName} 
        />

        <div className="ShareDetails__Col2--Label">Mobile Number</div>
        <input 
          type="number"
          maxLength={10}
          className="ShareDetails__Col2--Input" 
          onChange={e => this.handleMobileInput("mobileNumber",e)} 
          value={this.state.mobileNumber} 
        />

        <button disabled={submitDisabled} className="ShareDetails__Col2--Button" onClick={()=>this.handleSubmit()}>  Request a call back from us!</button>
      </div>

      <ToastContainer
        position={window.innerWidth < 700 ?"top-center":"top-right"}
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {
        isSubmitted && <Congratulations toggleCongratulations={this.toggleCongratulations} />
      }
      
    </div>
    )
  }
}




export default ShareDetails
// export default function ShareDetails() {
//   return (   
//   );
// }
